module.exports = __webpack_public_path__ + "img/9788963651279.2c3ffb24.jpg";